export default {
  data () {
    return {
      fields: [
        {
          prop: 'name',
          label: '一级科目名称',
          minWidth: 153,
        },
        {
          prop: 'created_at',
          label: '创建时间',
          minWidth: 120,
        },
        {
          prop: 'creator_name',
          label: '创建人',
          minWidth: 120,
        },
      ],
      secondFields: [
        {
          prop: 'name',
          label: '二级科目名称',
          minWidth: 153,
        },
        {
          prop: 'created_at',
          label: '创建时间',
          minWidth: 120,
        },
        {
          prop: 'creator_name',
          label: '创建人',
          minWidth: 100,
        },
      ],
      companyFields: [
        {
          prop: 'id',
          label: 'ID',
          width: 90,
        },
        {
          prop: 'name',
          label: '公司名称',
          minWidth: 120,
        },
        {
          prop: 'kingdee_number',
          label: '金蝶编码',
          minWidth: 80,
        },
        {
          prop: 'is_disabled',
          label: '启用状态',
          minWidth: 80,
          formatter: row => row.is_disabled ? '已禁用' : '启用中'
        },
        {
          prop: 'finance_lists',
          label: '财务负责人',
          minWidth: 200,
          formatter: (row) => row.finance_lists.map(item => `${item.user_name}/${item.id}`).join(', '),
        },
      ],
      invoiceNameFields: [
        {
          prop: 'name',
          label: '开票名称',
          minWidth: 120,
        },
        {
          prop: 'type_name',
          label: '开票名称类别',
          minWidth: 90,
        },
        {
          prop: 'tax_rate',
          label: '税率',
          minWidth: 60,
          formatter: row => row.tax_rate + '%'
        },
        {
          prop: 'product_num',
          label: '商品编码',
          minWidth: 90,
        },
        {
          prop: 'is_disabled',
          label: '禁用状态',
          minWidth: 60,
          formatter: row => row.is_disabled ? '已禁用' : '启用中'
        },
      ],
      invoiceNameTypeFields: [
        {
          prop: 'name',
          label: '开票类别名称',
          minWidth: 120,
        },
        {
          prop: 'is_disabled',
          label: '禁用状态',
          minWidth: 90,
          formatter: row => row.is_disabled ? '已禁用' : '启用中'
        },
      ],
      departmentFields: [
        {
          prop: 'name',
          label: '部门名称',
          minWidth: 120,
        },
        {
          prop: 'is_disabled',
          label: '状态',
          minWidth: 120,
          formatter: row => row.is_disabled ? '已禁用' : '启用中'
        },
      ],
      departmentJobFields: [
        {
          prop: 'id',
          label: 'ID',
          width: 90,
        },
        {
          prop: 'name',
          label: '岗位名称',
          minWidth: 120,
        },
      ],
      relationshipFields: [
        {
          prop: 'name',
          label: '付款类型',
          minWidth: 120,
          formatter: row => this.payment_apply_payment_type[row.payment_apply_type] && this.payment_apply_payment_type[row.payment_apply_type].name
        },
        {
          prop: 'name',
          label: '一级科目',
          formatter: row => this.first_subject_source[row.first_subject_id] && this.first_subject_source[row.first_subject_id].name
        },
      ],
      companyAccountFields: [
        {
          prop: 'id',
          label: 'ID',
          width: 90,
        },
        {
          prop: 'name',
          label: '账户名称',
          minWidth: 120,
        },
        {
          prop: 'number',
          label: '银行卡号',
          minWidth: 120,
        },
        {
          prop: 'our_companies_name',
          label: '所属公司',
          minWidth: 120,
        },
        {
          prop: 'bank_name',
          label: '开户银行',
          minWidth: 120,
        },
      ]
    }
  },
  computed: {
    ...Vuex.mapState({
    }),
  },
  methods: {
  },
}



// WEBPACK FOOTER //
// ./src/views/finance-config/finance-config.mixins.js